import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-bold q-pb-md" }

import { useDialogPluginComponent } from "quasar"
import SfxDialogHttpBase from "src/components/dialogs/http/SfxDialogHttpBase.vue"
import { IMG_MASCOT_TIME } from "src/util/constants/files"

//region Variables


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogHttp504',
  setup(__props) {

const { dialogRef, onDialogOK } = useDialogPluginComponent()

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(SfxDialogHttpBase, {
        title: _ctx.$t('sfxDialogHttp.title_504'),
        "http-code": "504",
        "img-src": _unref(IMG_MASCOT_TIME),
        onClick: _unref(onDialogOK)
      }, {
        body: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t("sfxDialogHttp.body_504_1")), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.$t("sfxDialogHttp.body_504_2")), 1)
        ]),
        quote: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("sfxDialogHttp.quote_504")), 1)
        ]),
        _: 1
      }, 8, ["title", "img-src", "onClick"])
    ]),
    _: 1
  }, 512))
}
}

})